// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jm-2";
export var container = "_jm-4";
export var dismissButton = "_jm-3";
export var hasPaddingBottom = "_jm-6";
export var last = "_jm-e";
export var scrollbarThumb = "_jm-c";
export var scrollbarTrack = "_jm-b";
export var selected = "_jm-9";
export var spin = "_jm-1";
export var spinning = "_jm-0";
export var suggestionItem = "_jm-d";
export var suggestionsPanel = "_jm-5";
export var tonePill = "_jm-8";
export var tonesContainer = "_jm-7";
export var unselected = "_jm-a";